var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/fgk-product.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("太保建筑行业灵活用工保（限广东企业）")]),
                  _c("div", [
                    _vm._v("行业超低价 | 中国太平洋承保 | 全线上操作"),
                  ]),
                  _c("p", [
                    _vm._v(
                      "\n\t\t\t\t\t\t① 行业首创新市民专属保障产品方案，更贴心、更全面\n\t\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t\t② 覆盖定制新市民群体职业风险特点，更适合、更可靠\n\t\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t\t③ 符合行业灵活用工等新就业形态人员，更安心、更省心\n\t\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t\t④ 3人起保，最高保额120万，社保用药、误工费、猝死有保障\n\t\t\t\t\t"
                    ),
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "medium", type: "warning" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.handleInsure(0)
                            },
                          },
                        },
                        [_vm._v("立即投保")]
                      ),
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "5px" },
                      attrs: {
                        loading: _vm.isDownLoading,
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t\t下载新市民保职业类别表\n\t\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "plan",
                    attrs: {
                      "cell-style": _vm.onCellStyle,
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        "margin-bottom": "10px",
                        "margin-top": "20px",
                      },
                    },
                    [
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("批增规则"),
                      ]),
                    ]
                  ),
                  _c("avue-crud", {
                    ref: "add",
                    attrs: {
                      data: _vm.dataAddFeeRate,
                      option: _vm.optionAddFeeRate,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                {
                  staticStyle: { "font-weight": "bold" },
                  attrs: { header: "短期单" },
                },
                [
                  _c("avue-crud", {
                    ref: "premium",
                    attrs: {
                      data: _vm.dataPremium,
                      option: _vm.optionPremium,
                      "span-method": _vm.spanMethodPremium,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "赔付标准" } },
                [
                  _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          color: "Red",
                          "margin-bottom": "20px",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t社保用药范围100%赔付，伤残等级对应赔付比例请查看附表\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: {
                        data: _vm.dataBenefit,
                        option: _vm.optionBenefit,
                      },
                    },
                    [_c("template", { slot: "header" })],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              qa.question ===
                                "广东新市民保（建筑行业）的保险责任是什么？" ||
                              qa.question ===
                                "是否可保承揽关系，什么是承揽关系？"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "bold",
                                        color: "red",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(qa.question) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { "font-weight": "bold" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(qa.question) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              qa.question ===
                              "是否可保承揽关系，什么是承揽关系？"
                                ? _c("span", [_vm._v(_vm._s(qa.anwser))])
                                : _c("span", [_vm._v(_vm._s(qa.anwser))]),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("h3", [_vm._v("保险条款及须知")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t1. 本保险适用以下保险条款： 2、本保险由中国太平洋财产保险股份有限公司承保，\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "承保区域为广东省范围内、仅限承保营业执照注册地址在广东的企业和组织"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t3、新市民是指：指因本人创业就业、子女上学、投靠子女等原因来到城镇常住,未获得当地户籍或获得当地户籍不满三年的各类群体,包括但不限于进城务工人员、新就业大中专毕业生等。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t4、新就业形态人员是指：是指以非全日制、临时性、季节性、弹性工作等灵活多样形式实现就业的人员。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t5、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t7、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t8、本保险根据投保单位的需求提供电子发票或纸质专票。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t9、本保险由博维保险经纪有限公司面向\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("广东省内销售并提供服务"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t10、\n\t\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t如被保险人未有员工出险，则保险人收取最低保费后，允许保单退保，并退还剩余保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                      ]),
                      _c("el-divider"),
                      _c("h3", [_vm._v("特别约定")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("1、保障期限："),
                        ]),
                        _c("br"),
                        _c("span", [_vm._v("只允许投保1、3、6、12个月。")]),
                        _c("br"),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("2、特约："),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（1）被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("超过72小时"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t才报案，则保险人对按保单约定的应承担的保险责任，\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("免赔50%"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t。如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（2）被保险人从业人员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t（3）\n\t\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "本保单可加人（不足1个月的按1个月收费），不可减人"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（4）如被保险人未有员工出险，则保险人收取最低保费后，允许保单退保，并退还剩余保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（5）本保单仅承保建筑相关行业，1-3类职业不保高空作业，4-6类职业可保高空作业。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t（6）\n\t\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t本保单拒绝承保职业：地下作业、塔吊安装拆除和维修、铁塔架设和拆除、窑炉/烟囱新建和拆除、钢结构、钢骨结构、涉及火药/炸药/爆破的相关工作和建筑拆除。\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（7）被保险人从业人员遭受伤害时，\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t实际从事的工作（不属于拒绝承保职业）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，免赔20%。如属于拒绝承保职业，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（8）在工作时间和工作岗位，\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("突发疾病死亡或者在48小时之内经抢救无效死亡"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（从业人员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "保险人承担赔偿责任，赔款=每人身故赔偿限额*20%"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t\t。\n\t\t\t\t\t\t\t"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（9）如被保险人从业人员遭遇保险事故导致身故，保险人根据《民法典》及《最高人民法院关于审理人身损害赔偿案件适用法律若干问题的解释》等相关法律法规计算从业人员的赔偿金额。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（10）如被保险人从业人员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（11）按伤残鉴定机构出具的伤残程度鉴定书，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例50%，七级伤残给付比例40%，\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "八级伤残给付比例20%，九级伤残给付比例10%，十级伤残给付比例5%。"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（12）医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准100%赔付。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（13）误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "被保险人从业人员仅接受门诊治疗的，按本保单约定无误工费赔付"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t\t。\n\t\t\t\t\t\t\t"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（14）被保险人从业人员\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "无安全带或者无特种作业操作证（包括但不限高处作业证）"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t，保险人承诺不拒赔；从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("免赔25%"),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t\t。\n\t\t\t\t\t\t\t"),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t（15）本保单\n\t\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("指定就诊医院为大陆境内二级及以上公立医院"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（16）在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t（17）\n\t\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t本保单仅承保施工地址在广东省内的工程项目。如施工地址在广东省外，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t（18）本保单承保法律费用责任，\n\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("累计赔偿限额为RMB10万元，"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t每次事故赔偿限额为RMB10万元。\n\t\t\t\t\t\t"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }